module.exports = __webpack_public_path__ + "system/img/help.babd9e50.png";